var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.box},[_c('div',{class:_vm.$style.container},[_c('img',{class:_vm.$style.image,attrs:{"src":require("@/assets/images/m-3d-loading.gif")}}),_c('div',{class:_vm.$style.horizon})])])}
var staticRenderFns = []

export { render, staticRenderFns }